(() => {
  const active = document.querySelector('.mh-support-nav a[aria-current=page]');
  if (active && matchMedia('(max-width: 999px)').matches) {
    const nav = active.closest('nav');
    nav.scrollLeft = Math.max(0, active.offsetLeft - nav.offsetLeft - 16);
  }
  const article = document.querySelector('[data-mh-document]');
  if (!article) return;
  // Inline legacy styles are presentation only. Never alter words, links or form fields.
  article.querySelectorAll('[style]').forEach(el => el.removeAttribute('style'));
  article.querySelectorAll('table').forEach((table, i) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'mh-document-table';
    wrapper.tabIndex = 0;
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', `Tabela ${i + 1} — przewiń, aby zobaczyć całość`);
    table.before(wrapper); wrapper.append(table);
  });
  const index = document.querySelector('.mh-document-index');
  if (!index) return;
  const headings = [...article.querySelectorAll('h2')];
  if (headings.length < 2) return;
  headings.forEach((heading, i) => {
    if (!heading.id) heading.id = `mh-document-section-${i + 1}`;
    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent.trim();
    index.querySelector('nav').append(link);
  });
  index.hidden = false;
  index.open = matchMedia('(min-width: 1000px)').matches;
})();
